import { apiClient } from 'shared/lib/apiClient';
import type {
  ChallengeResult,
  CredentialsResult,
  OtpMethod,
  PartnerSummary,
} from '../types';

export interface VerifyCredentialsPayload {
  phone: string;
}

export const partnerAuthService = {
  async verifyCredentials(
    payload: VerifyCredentialsPayload,
  ): Promise<CredentialsResult> {
    const { data } = await apiClient.post<CredentialsResult>(
      '/partner-auth/verify-credentials',
      payload,
    );
    return data;
  },

  async sendOtp(ticketId: string, method: OtpMethod): Promise<ChallengeResult> {
    const { data } = await apiClient.post<ChallengeResult>(
      '/partner-auth/send-otp',
      { ticketId, method },
    );
    return data;
  },

  async resendOtp(challengeId: string): Promise<ChallengeResult> {
    const { data } = await apiClient.post<ChallengeResult>(
      '/partner-auth/resend-otp',
      { challengeId },
    );
    return data;
  },

  async verifyOtp(
    challengeId: string,
    code: string,
  ): Promise<{ partner: PartnerSummary }> {
    const { data } = await apiClient.post<{ partner: PartnerSummary }>(
      '/partner-auth/verify-otp',
      { challengeId, code },
    );
    return data;
  },

  async logout(): Promise<void> {
    await apiClient.post('/partner-auth/logout');
  },

  async me(): Promise<PartnerSummary> {
    const { data } = await apiClient.post<PartnerSummary>('/partner-auth/me');
    return data;
  },

  async sendDashboardOtp(): Promise<ChallengeResult> {
    const { data } = await apiClient.post<ChallengeResult>(
      '/partner-auth/dashboard-otp/send',
    );
    return data;
  },

  async verifyDashboardOtp(
    challengeId: string,
    code: string,
  ): Promise<{ revealToken: string; expiresIn: number }> {
    const { data } = await apiClient.post<{
      revealToken: string;
      expiresIn: number;
    }>('/partner-auth/dashboard-otp/verify', { challengeId, code });
    return data;
  },
};
